import { TicketRepository } from '../repositories/TicketRepository'

export function DeleteNotificationAreaAssociationCase(
  ticketRepository: TicketRepository
) {
  return async function (associationId: string) {
    return await ticketRepository.deleteNotificationAreaAssociation(
      associationId
    )
  }
}
